import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CelumIcon } from '@celum/common-components/icon';
import { SanitizedPipe } from '@celum/ng2base/pipes';
import { LanguagePipe } from '@celum/ng2base/translation';

import { MessageConfiguration } from './message-configuration';

@Component({
  selector: 'message',
  templateUrl: './message.html',
  styleUrls: ['./message.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CelumIcon, LanguagePipe, SanitizedPipe]
})
export class Message {
  public configuration = input<MessageConfiguration>();
}
